import { createRoutes } from 'shared/hocs'

import { TournamentsOverview } from './overview'

const PublicRoutes = createRoutes(({ match }) => [
  {
    exact: true,
    path: match.path,
    component: TournamentsOverview,
  },
])

export default PublicRoutes
